import React, { useState, useEffect } from 'react'
import './styles.less'
import {
    Form,
    Select,
    notification,
    Button,
    Input,
    Upload,
} from 'antd';
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import Request from '../../request';
import { push } from 'connected-react-router';
import { ReactComponent as DialMantra } from '../../assets/dialMantra.svg'
import { ReactComponent as Drag } from '../../assets/drag.svg'
import _ from 'lodash'
import { useParams } from 'react-router';
import async from 'async'
import { getPushPathWrapper } from '../../routes';
import { ImageFileFormat } from '../../settings';
const { Option } = Select;

const Login = () => {
    const dispatch = useDispatch()
    const { token, uid } = useParams()
    const [form] = Form.useForm()
    const [loader, setLoader] = useState(false)
    const [userData, setUser] = useState({})
    const [formData, setFormData] = useState({})
    const [id, setStandardId] = useState([])
    const [proof, setAddressProof] = useState([])
    const [countries, setCountries] = useState([])
    const [formFileData, setData] = useState({})


    const onFinish = async (valData) => {
        setLoader(true)
        let { user, success, message, data } = await Request.resetPassword({ uid, token, password: valData.password })
        if (success) {
            notification.success({
                message: message || "success",
            })
            setTimeout(() => {

                window.location.href = '/'
            }, 3000)
        }
        else {
            notification.error({
                message: message || "Failed",
                description: JSON.stringify(data)?.replace('[', '')?.replace('{', '')?.replace(']', '')?.replace('}', '')
            })
        }
        setLoader(false)
    }

    function onChange(key, value) {
        setFormData((prev) => ({ ...prev, [key]: value }))
    }
    useEffect(() => {
    }, [])

    return (
        <div className="registration">
            {/* <div className="color">
            </div> */}
            <div className="dispayContent">
                <div className="">
                    <DialMantra width="20vw" height="16vh" />
                </div>
                <div className="">
                    <div className="subregistration">
                        Please Enter New Password !
                    </div>
                </div>
                <div className="drag">
                    <div>
                        <Form name="validate_other" onFinish={onFinish} >
                            <div className="marginLargetop"></div>
                            <div className='inputWidthNew  '>
                                <Form.Item
                                    name="password"
                                    label="New Password"
                                    maxLength={16}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password />
                                </Form.Item>
                                <Form.Item
                                    name="confirm_new_password"
                                    label="Confirm Password"
                                    dependencies={['password']}
                                    maxLength={16}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please confirm your password!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password />
                                </Form.Item>

                            </div>
                            <div style={{ justifyContent: "center", display: "flex", margin: "1rem" }} >
                                <Button loading={loader} htmlType="submit" color="#FF6600" style={{ width: "200px", borderRadius: '4px', backgroundColor: "#ff6600", color: "#fff" }}>Submit</Button>
                            </div>

                        </Form>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Login
